import React, { useState } from "react";
import { connect } from "react-redux";
import { useForm } from "react-hook-form";
import cleanDeep from "clean-deep";
import AllowanceRow from "../../../company-settings/allowance-tab/AllowanceRow";
import { PlusIcon, TrashIcon } from "@heroicons/react/20/solid";
import NoItemsRow from "../../NoItemsRow";
import { NotificationManager } from "react-notifications";
import Select from "react-select";

import { Actions as ALLOWANCEACTIONS } from "../../../../store/actions/allowanceActions";
import { useEffect } from "react";

const Allowances = ({
	existingCompanyDetails,
	updateCompanyDetails,
	addAllowance,
	nextPage,
	prevPage,
	disabled,
	advisor,
	templateOptions,
	selectedTemplate,
	templateAllowances,
	advisoryAllowances,
	applyTemplate,
	clearAllowances,
}) => {
	const { org, allowances } = existingCompanyDetails;

	const { handleSubmit } = useForm();

	const onSubmit = () => {
		let validation = allowances.every((allowance) => typeof allowance.method !== "undefined");

		if (!validation) {
			NotificationManager.error("Please make sure all Allowance Types are selected", "Saving Company Details");
			return;
		}

		updateCompanyDetails(
			cleanDeep({ org: org, allowances }, { emptyStrings: false, emptyArrays: false, emptyObjects: false }),
		);
		nextPage();
	};

	useEffect(() => {
		if (!selectedTemplate) return;

		templateAllowances?.map((a) => {
			if (allowances.find((al) => al?.id == a?.value)) return;
			addAllowance(a?.value);
		});
	}, [selectedTemplate]);

	return (
		<form onSubmit={handleSubmit(onSubmit)}>
			{advisor && templateOptions.length > 0 ? (
				<>
					<div className="col-xs-12 form-section">
						<div className="col-xs-6 pl-0">
							<h4>Apply Template</h4>
						</div>
						<div className="col-xs-12 pl-0 pb-6">
							<div className="form-material">
								<div className="col-xs-3 pl-0 pull-left">
									<Select
										valueName="selected"
										options={templateOptions}
										value={templateOptions.find((t) => t.value == selectedTemplate)}
										isDisabled={allowances.length > 0}
										placeholder="Choose one"
										onChange={(e) => {
											applyTemplate(e.value);
										}}
									/>
								</div>
								<div className="col-xs-3 pl-0 pull-left">
									<button
										className="btn btn-danger"
										type="button"
										onClick={() => {
											clearAllowances();
											applyTemplate(null);
										}}
									>
										<TrashIcon style={{ height: "1.5em", float: "left" }} />
									</button>
								</div>
							</div>
						</div>
					</div>
				</>
			) : null}

			<div className="col-xs-12 form-section">
				<div className="col-xs-6 pl-0">
					<h4>Allowances</h4>
				</div>
				{!disabled && (
					<button
						className="btn btn-success pull-right"
						type="button"
						onClick={() => {
							addAllowance();
						}}
					>
						<PlusIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
						<div style={{ float: "left" }}>Add Allowance</div>
					</button>
				)}

				<div className="clearfix" />
				<>
					{allowances?.length > 0 ? (
						allowances?.map((allowance) => {
							var fromTemplate = false;

							if (
								advisor &&
								selectedTemplate &&
								templateAllowances?.find((a) => a.value == allowance.id)
							) {
								allowance = advisoryAllowances.find((a) => a.id == allowance.id);
								fromTemplate = true;
							}
							return (
								<div
									className="col-xs-12"
									style={{ marginBottom: 10 }}
								>
									<AllowanceRow
										key={allowance.id}
										allowance={allowance}
										forModal={true}
										template={fromTemplate}
									/>
								</div>
							);
						})
					) : (
						<table
							id="table-timesheets"
							className="js-table-sections table table-hover"
						>
							<NoItemsRow name="Allowances" />
						</table>
					)}
				</>
			</div>

			<div style={{ marginTop: 10 }}>
				<a
					href="#"
					className="btn btn-default"
					onClick={prevPage}
				>
					Back
				</a>
				<button
					className="btn btn-success right"
					type="submit"
				>
					Save
				</button>
				<button
					className="btn btn-default right"
					style={{ marginRight: "1rem" }}
					type="submit"
				>
					Skip
				</button>
			</div>
		</form>
	);
};

const mapStateToProps = (state) => {
	const advisoryAllowances = state?.advisors?.settings?.allowances || [];
	const templates = state?.advisors?.settings?.templates || [];
	const selectedTemplate = state.company?.newCompany?.selectedAllowanceTemplate;

	const templateOptions = templates
		?.filter((t) => t.allowances && t.allowances.length > 0)
		.map((t) => ({ label: t?.name, value: t?.id }));

	console.debug("templateOptions", templateOptions);
	const templateAllowances = templates?.find((t) => t.id == selectedTemplate)?.allowances;

	return {
		existingCompanyDetails: state.company.newCompany,
		advisor: state.company?.newCompany?.advisor,
		templateOptions,
		selectedTemplate,
		templateAllowances,
		advisoryAllowances,
	};
};

const mapDispatchToProps = (dispatch) => ({
	applyTemplate: (template) => dispatch(ALLOWANCEACTIONS.allowancesApplyTemplate(template)),
	clearAllowances: () => dispatch(ALLOWANCEACTIONS.clearAllowance(true)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Allowances);
